export default "__VITE_ASSET__CbwZkd5K__"